import { useNavigate } from "react-router";
import { useAuth } from "./useAuth";
import { useCallback } from "react";
import { AUTH_PASSWORD, AUTH_USERNAME } from "../authConfig";

export const useLogin = () => {
  const user = useAuth();
  let navigate = useNavigate();

  const handleLogin = useCallback(
    (name, password) => {
      if (name === "" && password === "") {
        return "Wrong username or password";
      }

      if (name === AUTH_USERNAME && password === AUTH_PASSWORD) {
        localStorage.setItem("user", JSON.stringify({ name, password }));
        user.refetch();
        return navigate("/app");
      }

      return "Wrong username or password";
    },
    [navigate, user]
  );

  return handleLogin;
};
